import { NewsStatusEnum } from '@collections/news/enums/news.enums';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { NewsGQL, NewsResponse } from '@shared/services/news/news.gql.service';
import { LanguagesService } from '@shared/services/languages/languages.service';
import { NewsTypeEnum } from '@collections/news/enums/news.enums';
import { QueryRef } from 'apollo-angular';
import { NewsBlockComponent } from '../../../../news/views/news-block/news-block.component';
import { BlockHorizontalScrollerComponent } from '../../../../shared/components/block-horizontal-scroller/block-horizontal-scroller.component';
import { FullHeaderSliderComponent } from '../../../../layout/components/full-header-slider/full-header-slider.component';
import { UsersService } from 'app/shared/services/users/users.service';
@Component({
    selector: 'news-header',
    templateUrl: './news-header.component.html',
    styleUrls: ['./news-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FullHeaderSliderComponent, BlockHorizontalScrollerComponent, NewsBlockComponent]
})
export class NewsHeaderComponent implements OnInit {

  newsQuery: QueryRef<NewsResponse>;
  usersService = inject(UsersService);
  isUserLogged = signal(false);
  
  constructor(
    private languagesService: LanguagesService,
    private newsGQL: NewsGQL
  ) { }

  ngOnInit(): void {
    this.newsQuery = this.newsGQL.watch({
      newsType: NewsTypeEnum.portal,
      newsStatus: NewsStatusEnum.portalLevelValidated,
      lang: this.languagesService.getCurrentLangCode(),
      first: 6
    });

    this.usersService.onUserChange
    // .pipe(untilDestroyed(this)) // remove ???
    .subscribe(user => {
      if (user)
        this.isUserLogged.set(true)
  });
  }

}
